var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('carousel',{attrs:{"perPageCustom":[
    [320, 1],
    [768, 2],
    [1024, 3] ],"autoplay":true,"autoplayHoverPause":true,"paginationColor":'var(--grey-color)',"paginationActiveColor":'#d65a85'}},_vm._l((_vm.images),function(obj){return _c('slide',{key:obj.title,attrs:{"id":obj.title}},[_c('img',{staticClass:"imgPreview",attrs:{"src":obj.img}}),_c('button',{staticClass:"carousel--delBtn btn",on:{"click":_vm.deleteBook}},[_c('i',{staticClass:"fas fa-trash"})])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }